import React, { useEffect } from 'react';
import { DialogContentStyled, Label, LeftContentWrapper, RightContentWrapper } from 'components/Dialog/DialogContent';
import { LeftContent } from 'components/Dialog/DialogLeftContent';
import { Bottom, BottomActions, ConnectButton, RightForm } from 'components/Dialog/DialogRightContent';
import { ErrorMessage, Input, InputGrid } from 'components/Form';
import { SubmitHandler, useForm } from 'react-hook-form';
import { lazadaAuthorize } from 'api/marketPlaces';
import { channels } from 'shared/constants';
import { useAppStore } from 'stores/appStore';

import HorizontalDividers from 'components/CustomDividers/HorizontalDividers';
import VerticalDividers from 'components/CustomDividers/VerticalDividers';
import WarningIcon from '@mui/icons-material/Warning';
import { Button } from '@mui/material';
import { AsyncButton } from 'components/ButtonNew/Button';
import { set } from 'date-fns';
import ButtonReauthorization from 'pages/Onboarding/StepTwo/ButtonReauthorization';
import ButtonAuthorization from 'pages/Onboarding/StepTwo/ButtonAuthorization';

interface FormValues {
  store_name: string;
}

const LazadaContent: React.FunctionComponent<{ chData?: { store_name: string; channel_user_id: string }; isConnected?: boolean }> = ({ chData, isConnected = false }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm<FormValues>();
  const { indexAccordion, disablePrevButton } = useAppStore();
  const [busy, setBusy] = React.useState<boolean>(false);

  const onSubmit: SubmitHandler<FormValues> = async (formData) => {
    setBusy(true);
    try {
      const { data, status, statusText } = await lazadaAuthorize(
        formData?.store_name,
        indexAccordion,
        false
      );
      if (status === 200 && data.status === 'ok') {
        console.log('data.redirect ->', data.redirect)
        window.location.href = data.redirect;
      } else {
        console.error(`Something went wrong ${statusText}`);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (isConnected && chData?.channel_user_id) {
      // Set the store name from the connected data
      setValue('store_name', chData.channel_user_id);
    }
  }, [isConnected, chData, setValue]);

  return (
    <DialogContentStyled>
      <LeftContentWrapper>
        <LeftContent channelId={channels.LAZADA} />
      </LeftContentWrapper>
      <VerticalDividers />
      <RightContentWrapper>
        <RightForm id="lazada_form" onSubmit={handleSubmit(onSubmit)}>
          <InputGrid
            label={<Label className="requiredField">Email</Label>}
            input={
              <Input
                isError={errors.store_name?.message ? true : false}
                type={'store_name'}
                placeholder={'Masukkan email'}
                disabled={isConnected}
                {...register('store_name', {
                  required: { value: true, message: 'Email harus di isi' },
                  pattern: {
                    value:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: 'Email tidak valid'
                  }
                })}
              />
            }
            errorMessage={
              errors?.store_name && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.store_name.message}
                />
              )
            }
          />
        </RightForm>
        <Bottom>
          <HorizontalDividers />
          <BottomActions>
            <ButtonReauthorization {...{
              isConnected,
              form: 'lazada_form'
            }} />
            <ButtonAuthorization {...{
              form: 'lazada_form',
              disable: isConnected
            }} />
          </BottomActions>
        </Bottom>
      </RightContentWrapper>
    </DialogContentStyled>
  );
};

export default LazadaContent;
